export default function(ctx) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<!-- form fields which are grouped in a fieldset -->\n';
 if (ctx.component.type === 'radio' || ctx.component.type === 'selectboxes') { ;
__p += '\n  <div class="utrecht-form-fieldset utrecht-form-fieldset--openforms">\n    <fieldset\n      class="utrecht-form-fieldset__fieldset utrecht-form-fieldset--html-fieldset"\n      ';
 if (ctx.component.type === 'radio') { ;
__p += 'role="radiogroup"';
 } ;
__p += '\n      ';
 if (ctx.component.description) { ;
__p += 'aria-describedby="' +
((__t = (ctx.id)) == null ? '' : __t) +
'-description"';
 } ;
__p += '\n    >\n\n      <legend class="utrecht-form-fieldset__legend utrecht-form-fieldset__legend--html-legend utrecht-form-field__label">\n        <span class="utrecht-form-label utrecht-form-label--openforms';
 if (ctx.component.validate.required && ctx.requiredFieldsWithAsterisk){;
__p += ' utrecht-form-label--openforms-required';
};
__p += '">\n          ' +
((__t = ( ctx.t(ctx.component.label, { _userInput: true }) )) == null ? '' : __t) +
'\n          ';
 if (!ctx.component.validate.required && !ctx.requiredFieldsWithAsterisk) { ;
__p += '\n            ' +
((__t = ( ctx.t('(not required)') )) == null ? '' : __t) +
'\n          ';
 } ;
__p += '\n          ';
 if (ctx.component.tooltip) { ;
__p += '\n            <i ref="tooltip" class="openforms-tooltip-icon ' +
((__t = (ctx.iconClass('question-sign'))) == null ? '' : __t) +
'"data-tooltip="' +
((__t = ( ctx.tooltip )) == null ? '' : __t) +
'"></i>\n          ';
 } ;
__p += '\n        </span>\n      </legend>\n\n      ' +
((__t = (ctx.element)) == null ? '' : __t) +
'\n\n      ';
 if (ctx.component.description) { ;
__p += '\n        <div\n          class="utrecht-form-field-description utrecht-form-field-description--openforms-helptext"\n          id="' +
((__t = (ctx.id)) == null ? '' : __t) +
'-description"\n        >\n          ' +
((__t = (ctx.component.description)) == null ? '' : __t) +
'\n        </div>\n      ';
 } ;
__p += '\n\n      <div\n        ref="messageContainer"\n        class="utrecht-form-field-description utrecht-form-field-description--invalid utrecht-form-field-description--openforms-errors"\n        role="alert"\n        id="' +
((__t = (ctx.instance.id)) == null ? '' : __t) +
'-' +
((__t = (ctx.component.key)) == null ? '' : __t) +
'-error-message"></div>\n\n    </fieldset>\n  </div>\n\n<!-- layout/container fields -->\n';
 } else if (ctx.component.type === 'form') { ;
__p += '\n\n  ' +
((__t = (ctx.element)) == null ? '' : __t) +
'\n\n<!-- leaf nodes -->\n';
 } else { ;
__p += '\n  <div class="utrecht-form-field\n              utrecht-form-field--' +
((__t = (ctx.component.type)) == null ? '' : __t) +
'\n              utrecht-form-field--openforms\n              ';
 if (ctx.component?.openForms?.requireVerification) { ;
__p += 'utrecht-form-field--has-button';
 } ;
__p += '\n  ">\n    ';
 if (!ctx.label.hidden && ctx.label.labelPosition !== 'bottom') { ;
__p += '\n      ' +
((__t = ( ctx.labelMarkup )) == null ? '' : __t) +
'\n    ';
 } ;
__p += '\n\n    ';
 if (ctx.label.hidden && ctx.label.className && ctx.component.validate.required && ctx.requiredFieldsWithAsterisk) { ;
__p += '\n      <label class="utrecht-form-label utrecht-form-label--openforms utrecht-form-label--openforms-required ' +
((__t = (ctx.label.className)) == null ? '' : __t) +
'"></label>\n    ';
 } ;
__p += '\n\n    ' +
((__t = (ctx.element)) == null ? '' : __t) +
'\n\n    ';
 if (!ctx.label.hidden && ctx.label.labelPosition === 'bottom') { ;
__p += '\n      ' +
((__t = ( ctx.labelMarkup )) == null ? '' : __t) +
'\n    ';
 } ;
__p += '\n\n    ';
 if (ctx.component.description) { ;
__p += '\n      <div class="utrecht-form-field-description utrecht-form-field-description--openforms-helptext">' +
((__t = (ctx.component.description)) == null ? '' : __t) +
'</div>\n    ';
 } ;
__p += '\n\n    <div\n      ref="messageContainer"\n      class="utrecht-form-field-description utrecht-form-field-description--invalid utrecht-form-field-description--openforms-errors"\n      role="alert"\n      id="' +
((__t = (ctx.instance.id)) == null ? '' : __t) +
'-' +
((__t = (ctx.component.key)) == null ? '' : __t) +
'-error-message"></div>\n  </div>\n';
 } ;
__p += '\n';
return __p
}